import { __awaiter } from '../_virtual/_tslib.js';
import { useQueryClient } from 'react-query';
import { generateUrlParamsFromObject } from '../methods/generateUrlParamsFromObject.js';
import { QueryNames } from '../_services/hooks/queryNames.js';
import { getAuthHeader } from '../_services/utils/getAuthHeader.js';

const useVahakHttpClient = () => {
    const queryClient = useQueryClient();
    const calculateAuthHeader = () => {
        const authHeaderObj = getAuthHeader();
        return (authHeaderObj === null || authHeaderObj === void 0 ? void 0 : authHeaderObj.token.includes("undefined")) ? {} : authHeaderObj;
    };
    function calculatePath(path, queryParamObj) {
        const _path = queryParamObj
            ? `${path}${path.includes("?") ? "" : "?"}${generateUrlParamsFromObject(queryParamObj)}`
            : path;
        return _path;
    }
    function invokeHttpCall(path, config) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = new Request(path, config);
            let responseJSON;
            try {
                const response = yield fetch(request);
                responseJSON = yield response.json();
                if (response.ok) {
                    if (response.status === 208) {
                        throw responseJSON;
                    }
                    return Promise.resolve(responseJSON);
                }
                else {
                    if (response.status === 401)
                        queryClient.invalidateQueries(QueryNames.validateToken);
                    // This will call the error block
                    throw Object.assign({ statusCode: response.status, statusText: response.statusText }, responseJSON);
                }
            }
            catch (err) {
                return Promise.reject(err);
            }
        });
    }
    function GET(path, queryParamObj, customHeaders) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = { headers: Object.assign(Object.assign({}, customHeaders), calculateAuthHeader()) };
            const init = Object.assign({ method: "GET" }, config);
            const _path = calculatePath(path, queryParamObj);
            return invokeHttpCall(_path, init);
        });
    }
    function POST(path, body, formData, queryParamObj, customHeaders) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = formData
                ? {
                    headers: Object.assign({}, calculateAuthHeader())
                }
                : {
                    headers: Object.assign(Object.assign(Object.assign({}, customHeaders), calculateAuthHeader()), { Accept: "application/json", "Content-Type": "application/json" })
                };
            const init = Object.assign({ method: "POST", body: formData ? formData : JSON.stringify(body) }, config);
            const _path = calculatePath(path, queryParamObj);
            return invokeHttpCall(_path, init);
        });
    }
    function PUT(path, body, queryParamObj, customHeaders) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                headers: Object.assign(Object.assign(Object.assign({}, customHeaders), calculateAuthHeader()), { Accept: "application/json", "Content-Type": "application/json" })
            };
            const init = Object.assign({ method: "PUT", body: JSON.stringify(body) }, config);
            const _path = calculatePath(path, queryParamObj);
            return invokeHttpCall(_path, init);
        });
    }
    function DELETE(path, queryParamObj, customHeaders) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = { headers: Object.assign(Object.assign({}, customHeaders), calculateAuthHeader()) };
            const init = Object.assign({ method: "DELETE" }, config);
            const _path = calculatePath(path, queryParamObj);
            return invokeHttpCall(_path, init);
        });
    }
    return {
        GET,
        PUT,
        POST,
        DELETE
    };
};

export { useVahakHttpClient as default };
//# sourceMappingURL=useVahakHttpClient.js.map
